import React, {forwardRef} from "react";
import BookingsMainHeader from "../subComponents/BookingsMainHeader";
import CustomTable from "../../../../components/table/CustomTable";
import CustomModal from "../../../../components/Modal/CustomModal";
import DeleteModal from "../../../Modals/DeleteModal";
import CustomDescriptionLabel from "../../../../components/CustomDescriptionLabel";
import {ReservationsStatusTableApp} from "./Functionality/ReservationsStatusTableApp";
import {VIEW_TYPE} from "../../../../enums/ViewType";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const ReservationsStatus = forwardRef((props, ref) => {

    const {
        selectedList,
        setSelectedList,
        subView,
        handleSubViewChange,
        searchElement,
        setSearchElement,
        permission,
        DEV,
        option,
        setSearch,
        simpleSearch,
        setSimpleSearch,
        setBodyForExport,
    } = props;

    const {
        tableId,
        searchId,
        thead,
        tbody,
        getActionsButtons,
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        page,
        rowsPerPage,
        setResults,
        results,
        isAllChecked,
        showCancelModal,
        showDeleteModal,
        handleHideModals,
        handleCancelEventByList,
        handleDeleteEventByList,
        t,
        showCheckbox
    } = ReservationsStatusTableApp({
        selectedList,
        setSelectedList,
        setBodyForExport,
        setSearch,
        option,
        ref,
        searchElement
    });


    return (
        <>
            <BookingsMainHeader
                subView={subView}
                handleSubViewChange={handleSubViewChange}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                permission={permission}
                DEV={DEV}
                option={option}
                page={page}
                rowsPerPage={rowsPerPage}
                setSearchResults={setResults}
                searchResults={results}
                setSearch={setSearch}
                simpleSearch={simpleSearch}
                setSimpleSearch={setSimpleSearch}
                viewType={VIEW_TYPE.LIST.viewType}
                setBodyForExport={setBodyForExport}
            />

            <CustomTable
                tableId={tableId}
                searchId={searchId}
                checkbox={showCheckbox}
                checkboxTitle={'de_/_select_all'}
                isAllChecked={isAllChecked}
                onChangeCheckbox={handleDeleteAll}
                thead={thead}
                tbody={tbody}
                columnActions={true}
                getActionsButtons={getActionsButtons}
                handleCheckboxChange={handleCheckboxChange}
                selectedList={selectedList}
                textNotInformation={"you_dont_have_any_requests_yet"}
            />
            {pagination()}

            {showDeleteModal && (
                <DeleteModal
                    show={showDeleteModal}
                    onHide={() => {
                        handleHideModals();
                    }}
                    onClickFn={() => {
                        handleDeleteEventByList();
                    }}
                    data={selectedList}
                    title_modal={t('delete_reservations')}
                    description={'are_you_sure_you_want_to_delete'}
                    element_modal={t('reservations')}
                />
            )}

            {showCancelModal && (
                <CustomModal
                    title='cancel_reservation'
                    show={showCancelModal}
                    onHide={()=>{
                        handleHideModals();
                    }}
                    onConfirm={() => {
                        handleCancelEventByList();
                    }}
                    buttonConfirm='confirm'
                    size="md"
                    classNameBody="pt-2"
                >
                    <div className='col-12 d-flex justify-content-center text-center'>
                        <CustomDescriptionLabel trans={t('are_you_sure_to_proceed')} bold='normal' />
                    </div>
                </CustomModal>
            )}
        </>
    )
})

export default ReservationsStatus
